'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _LookUp = require('../LookUp');

var _LookUp2 = _interopRequireDefault(_LookUp);

var _Fieldset = require('../Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _rules = require('../Webform/rules');

var _rules2 = _interopRequireDefault(_rules);

var _RuleHint = require('../RuleHint');

var _RuleHint2 = _interopRequireDefault(_RuleHint);

var _WebformUtils = require('../WebformUtils');

var _WebformUtils2 = _interopRequireDefault(_WebformUtils);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

var _wrapper = require('../Fieldset/styled/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _validationMessage = require('../LookUp/styled/validation-message');

var _validationMessage2 = _interopRequireDefault(_validationMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Address = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Address, _Component);

  function Address(props) {
    (0, _classCallCheck3.default)(this, Address);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Address.__proto__ || (0, _getPrototypeOf2.default)(Address)).call(this, props));

    var field = props.formStore.getField(props.field['#webform_key']);

    var lookUpIsBlocking = field.element['#address_validation'] || field.parent && field.parent.element['#address_validation'];

    _this.lookUpFields = {
      street: {
        elementKey: 'street',
        formKey: 'address_street' + props.formKeySuffix,
        apiValue: function apiValue(address) {
          return address.street;
        },
        hideField: true,
        disableField: lookUpIsBlocking
      },
      postcode: {
        elementKey: 'postcode',
        formKey: 'address_postcode' + props.formKeySuffix,
        apiValue: function apiValue(address) {
          return (address.postcode || '').toUpperCase();
        },
        triggerLookUp: true
      },
      number: {
        elementKey: 'number',
        formKey: 'address_number' + props.formKeySuffix,
        apiValue: function apiValue() {
          return false;
        },
        triggerLookUp: true
      },
      addition: {
        elementKey: 'addition',
        formKey: 'address_number_add' + props.formKeySuffix,
        apiValue: function apiValue() {
          return false;
        },
        triggerLookUp: true
      },
      city: {
        elementKey: 'city',
        formKey: 'address_city' + props.formKeySuffix,
        apiValue: function apiValue(address) {
          return address.city.label;
        },
        hideField: true,
        disableField: lookUpIsBlocking
      },
      locationLat: {
        elementKey: 'locationLat',
        formKey: 'address_location_lat' + props.formKeySuffix,
        apiValue: function apiValue(address) {
          return address.geo.center.wgs84.coordinates[1];
        }
      },
      locationLng: {
        elementKey: 'locationLng',
        formKey: 'address_location_lng' + props.formKeySuffix,
        apiValue: function apiValue(address) {
          return address.geo.center.wgs84.coordinates[0];
        }
      },
      manualOverride: {
        elementKey: 'manualOverride',
        formKey: 'address_manual_override' + props.formKeySuffix,
        apiValue: function apiValue() {
          return false;
        }
      }
    };

    _this.lookUpBase = props.url + '/postcode-api/address?_format=json';

    var lookUpKey = _this.getLookUpKey(props);

    _rules2.default.set('address_' + props.field['#webform_key'], {
      rule: function rule() {
        var lookUp = (0, _mobx.get)(field.lookUps, lookUpKey);
        return !lookUpIsBlocking || !lookUp || !lookUp.lookUpSent || lookUp.lookUpSent && lookUp.lookUpSuccessful;
      },
      hint: function hint() {
        return null;
      },
      shouldValidate: function shouldValidate() {
        return props.fields.reduce(function (shouldValidate, item) {
          return shouldValidate && !item.isEmpty && item.isBlurred && item.valid;
        }, true);
      }
    });

    props.registerLookUp(lookUpKey, _this.lookUpFields, true);
    return _this;
  }

  (0, _createClass3.default)(Address, [{
    key: 'getLookUpKey',
    value: function getLookUpKey(props) {
      return (props || this.props).field['#webform_key'] + '-address';
    }
  }, {
    key: 'prepareLookUp',
    value: function prepareLookUp(fields) {
      var postCodeField = this.props.getField('postcode').field;
      var numberField = this.props.getField('number').field;

      if (!fields.postcode || !postCodeField || !numberField || !postCodeField.valid || !fields.number || !numberField.valid) {
        return false;
      }

      var query = '&postcode=' + fields.postcode.toUpperCase() + (fields.number ? '&number=' + fields.number : '');

      return {
        query: query,
        // eslint-disable-next-line no-underscore-dangle
        checkResponse: function checkResponse(json) {
          return json;
        },
        isSuccessful: function isSuccessful(json) {
          return !!json.id;
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var field = this.props.formStore.getField(this.lookUpFields.postcode.formKey);
      var lookUpKey = this.getLookUpKey();
      var lookUp = (0, _mobx.get)(field.lookUps, lookUpKey);

      return _react2.default.createElement(
        _Fieldset2.default,
        this.props,
        lookUp && lookUp.lookUpSent && !lookUp.lookUpSuccessful && _react2.default.createElement(_RuleHint2.default, {
          component: _react2.default.createElement(_validationMessage2.default, null),
          key: 'address_' + this.props.field['#webform_key'],
          hint: _WebformUtils2.default.getCustomValue(this.props.field, 'addressError', this.props.settings) || _WebformUtils2.default.getErrorMessage(this.props.field, '#required_error') || 'We don\'t recognise this address. Please check again, or proceed anyway.'
        })
      );
    }
  }]);
  return Address;
}(_react.Component), _class2.meta = {
  wrapper: _wrapper2.default,
  label: _Fieldset2.default.meta.label,
  wrapperProps: _Fieldset2.default.meta.wrapperProps,
  labelVisibility: _Fieldset2.default.meta.labelVisibility,
  validations: [function (el) {
    return 'address_' + el.key;
  }],
  hasValue: false
}, _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#webform_key': _propTypes2.default.string.isRequired,
    '#addressError': _propTypes2.default.string,
    composite_elements: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
    parent: _propTypes2.default.shape({
      props: _propTypes2.default.shape({
        field: _propTypes2.default.shape()
      })
    })
  }).isRequired,
  getField: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  formKeySuffix: _propTypes2.default.string.isRequired,
  url: _propTypes2.default.string.isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired,
  fields: _propTypes2.default.arrayOf(_propTypes2.default.shape()).isRequired,
  settings: _propTypes2.default.shape().isRequired,
  registerLookUp: _propTypes2.default.func.isRequired
}, _temp)) || _class;

exports.default = (0, _LookUp2.default)(Address);